import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { DropdownModule } from '@epicuro-next/ataraxia/dropdown';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { MediaModule } from '@epicuro-next/ataraxia/media';
import { dynamicElementsSimpleSelectKey } from '@epicuro-next/constants/dynamic-elements';
import { DontTreeShake } from '@epicuro-next/elements/core';
import { DynamicComponentRegister } from '@epicuro-next/platform/dynamic-components-registrator';

export type SimpleSelectOptionType = {
  value: string;
  displayValue: string;
  icon?: string | null;
};

@DynamicComponentRegister(dynamicElementsSimpleSelectKey, true)
@Component({
  selector: 'atx-simple-select',
  templateUrl: './simple-select.component.html',
  styleUrls: ['./simple-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, MediaModule, DropdownModule, IconsModule],
})
export class SimpleSelectComponent {
  @Input() public options: SimpleSelectOptionType[] = [];
  @Input() public selectedValue?: string;
  @Output() public selectionChanged =
    new EventEmitter<SimpleSelectOptionType>();

  public isCurrentlySelected(option: SimpleSelectOptionType): boolean {
    return option.value === this.selectedValue;
  }

  public onClick(option: SimpleSelectOptionType): void {
    if (this.selectedValue === option.value) {
      return;
    }

    this.selectedValue = option.value;
    this.selectionChanged.emit(option);
  }

  public get optionList() {
    return Array.isArray(this.options) ? this.options : [];
  }
}
DontTreeShake(SimpleSelectComponent);
